import React from 'react';
import { observer } from 'mobx-react';
import { observable, toJS } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import { getDisplayDate } from '../libs/date';
import StepRangeSlider from 'react-step-range-slider';

@observer
class ImageSlider extends React.Component {

  @observable images = [];
  @observable index = 0;
  @observable play = false;

  componentWillMount() {
    const { images, play, selectedIndex } = this.props;
    this.play = play;
    if (!!images.length) {
      this.images = images;
      this.index = selectedIndex || 0;
      this.props.onChangeImage(this.images[this.index], this.index);
      this.startSlider();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(toJS(this.props.images), toJS(nextProps.images))) {
      this.images = nextProps.images;
      this.index = nextProps.selectedIndex || 0;
      this.props.onChangeImage(this.images[this.index], this.index);
      this.startSlider();
    }
  }

  componentWillUnmount() {
    this.stopSlider();
  }

  startSlider = () => {
    if (this.play) {
      this.stopSlider();
      this.slideTimer = setInterval(this.changeIndex, 1000);
    }
  };

  stopSlider = () => {
    if (this.slideTimer) {
      clearInterval(this.slideTimer);
      this.slideTimer = null;
    }
  };

  changeIndex = (step = 1) => {
    let newIndex = 0;
    if (step > 0 && this.index >= this.images.length - 1) newIndex = 0;
    else if (step < 0 && this.index === 0) newIndex = this.images.length - 1;
    else newIndex = this.index + step;

    this.index = newIndex;
    this.props.onChangeImage(this.images[newIndex], newIndex);
  };

  togglePlay = () => {
    this.play = !this.play;
    if (this.play) this.startSlider();
    else this.stopSlider();
  };

  returnSelectedTimeRange = (images, key) => {
    let timeRange = {};

    images.forEach(image => {
      const time = image[key];
      const date = moment(time).valueOf();
      if (!timeRange[date]) timeRange = Object.assign(timeRange, { [date]: time });
    });

    return Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
      value: index,
      epoch: key,
      date: timeRange[key]
    }));
  }

  render() {
    const { baseUrl, filterKey, noSlider, height, width, children } = this.props;
    if (!this.images.length) return <div />;
    let dateRange = this.returnSelectedTimeRange(this.images, filterKey)
    let style = {};
    if (!!height) style.height = height;
    if (!!width) style.width = width;

    return (
      <div>
        <div className='image-slider' style={style}>
          <img src={`${baseUrl || ''}/${this.images[this.index === 0 ? this.images.length - 1 : this.index - 1].source}`} style={{ display: 'none' }} alt='not-found' />
          <div className='image-slider-image'>
            <img src={`${baseUrl || ''}/${this.images[this.index].source}`} alt='not-found' />
          </div>
          <img src={`${baseUrl || ''}/${this.images[this.index === this.images.length - 1 ? 0 : this.index + 1].source}`} style={{ display: 'none' }} alt='not-found' />

          {!this.play && <a className='image-slider-control image-slider-left' onClick={() => this.changeIndex(-1)}><span className="fa fa-chevron-left white" /></a>}
          {!this.play && <a className='image-slider-control image-slider-right' onClick={() => this.changeIndex(1)}><span className="fa fa-chevron-right white" /></a>}

          <span className='image-slider-control image-slider-indicator'>{`${this.index + 1}/${this.images.length}`}</span>
          <a className='image-slider-control image-slider-center' onClick={this.togglePlay}><span className={this.play ? 'fa fa-pause white' : 'fa fa-play white'} /></a>
        </div>

        {!noSlider && dateRange.length > 0 && <StepRangeSlider
          ref={(ref) => this.ref = ref}
          value={this.index}
          range={dateRange}
          onChange={index => this.index = index}
          children={null}
        />}
        {!noSlider && !!dateRange[this.index] && <span style={{
          marginLeft: `calc(${(this.index / (dateRange.length - 1)) * 100}% - (${(this.index / (dateRange.length - 1)) * 126}px))`,
          whiteSpace: 'nowrap',
          transition: '0.1s linear'
        }}>{getDisplayDate(dateRange[this.index].date, { format: 'YYYY-MM-DD HH:mm' })}</span>}
      </div>
    );
  }
}

export default ImageSlider;


// WEBPACK FOOTER //
// ./src/components/ImageSlider.js